function deleteAdminDesignerDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/delete-admin-designer/delete-admin-designer-dialog.html?$$REVISION$$'
  }
}

export { deleteAdminDesignerDialog }
